export default __webpack_public_path__ + "static/media/paypal.d4845648.png";